'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import Cookies from 'js-cookie';
import React__default, { useState, useCallback, useEffect } from 'react';
import Slider from '../Slider/index.js';
import JobBlock from './JobBlock/index.js';
import Section from './Section/index.js';
import { getLastViewJobId } from './helper.js';
import { getRecommendJobs } from './services.js';
import { getSpecialJob } from '../JobYouWillLove/services.js';
import { ELanguage } from '../Utils/constants.js';

var isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;
var ITEMS_PER_SLIDE = isMobile ? 4 : 3;
var LANGUAGE_CODE_VN = 1;
var RecommnendJobs = function (props) {
    var _a;
    var _b = props.jobId, jobId = _b === void 0 ? '' : _b, apiUrl = props.apiUrl, languageCode = props.languageCode, limit = props.limit, user = props.user, userInfo = props.userInfo, userIP = props.userIP, utmData = props.utmData, vnwBaseURL = props.vnwBaseURL, _c = props.sectionTitle, sectionTitle = _c === void 0 ? '' : _c, _d = props.ssrJobs, ssrJobs = _d === void 0 ? [] : _d, _e = props.isWrapper, isWrapper = _e === void 0 ? false : _e, ctaLink = props.ctaLink, _f = props.isHotJob, isHotJob = _f === void 0 ? false : _f, handleNoJobs = props.handleNoJobs, onDataSourceComplete = props.onDataSourceComplete, previewJob = props.previewJob, _g = props.classSelector, classSelector = _g === void 0 ? '' : _g, initData = props.initData;
    var _h = useState(ssrJobs), jobs = _h[0], setJobs = _h[1];
    var _j = useState(false), forceHidden = _j[0], setForceHidden = _j[1];
    var _k = useState(true), isRobot = _k[0], setIsRobot = _k[1];
    var _l = useState((previewJob === null || previewJob === void 0 ? void 0 : previewJob.accessToken) || ''), accessToken = _l[0], setAccessToken = _l[1];
    var _m = previewJob || {}, _o = _m.enablePreviewJob, enablePreviewJob = _o === void 0 ? false : _o, _p = _m.msUrl, msUrl = _p === void 0 ? '' : _p;
    var langCode = languageCode === LANGUAGE_CODE_VN ? ELanguage.VI : ELanguage.EN;
    var handleNoJobsFound = function () {
        handleNoJobs === null || handleNoJobs === void 0 ? void 0 : handleNoJobs();
        setForceHidden(true);
    };
    var invokedGetJobs = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var userId, lastViewJobId, data, reformatJobs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    userId = user;
                    lastViewJobId = jobId || getLastViewJobId((Cookies === null || Cookies === void 0 ? void 0 : Cookies.get('VNW_LAST_JOB_SEEN')) || '', Number.parseInt(userId, 10));
                    return [4 /*yield*/, getRecommendJobs(lastViewJobId || 0, userId || userIP, languageCode, limit, apiUrl, vnwBaseURL, utmData)];
                case 1:
                    data = _a.sent();
                    if (!enablePreviewJob) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSpecialJob({
                            baseUrl: msUrl,
                            accessToken: accessToken,
                            jobs: data
                        })];
                case 2:
                    reformatJobs = _a.sent();
                    reformatJobs.data.length > 0 ? setJobs(reformatJobs.data) : handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    onDataSourceComplete === null || onDataSourceComplete === void 0 ? void 0 : onDataSourceComplete(reformatJobs.data);
                    return [3 /*break*/, 4];
                case 3:
                    data.length > 0 ? setJobs(data) : handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    onDataSourceComplete === null || onDataSourceComplete === void 0 ? void 0 : onDataSourceComplete(data);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    console.log(err_1);
                    handleNoJobsFound === null || handleNoJobsFound === void 0 ? void 0 : handleNoJobsFound();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        var _a, _b;
        if ((_a = props.previewJob) === null || _a === void 0 ? void 0 : _a.accessToken) {
            setAccessToken((_b = props.previewJob) === null || _b === void 0 ? void 0 : _b.accessToken);
        }
    }, [props.previewJob]);
    useEffect(function () {
        invokedGetJobs();
        setIsRobot(false);
    }, [invokedGetJobs]);
    var tempUserInfo = __assign(__assign({}, userInfo), { jobLevelId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId[0], id: (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _a !== void 0 ? _a : 0 });
    var renderSlideContent = function () {
        var slidesContent = [];
        var jobsPerPage = [];
        var slideIndex = 0;
        jobs.forEach(function (job, index) {
            var isFinalIndex = (jobs.length <= ITEMS_PER_SLIDE && index === jobs.length - 1) ||
                jobsPerPage.length === ITEMS_PER_SLIDE - 1;
            jobsPerPage.push(React__default.createElement("div", { className: '', key: index },
                React__default.createElement(JobBlock, { isFinalIndex: isFinalIndex, langCode: langCode, job: job, enablePreviewJob: enablePreviewJob, isHotJob: isHotJob, accessToken: accessToken, msUrl: msUrl, vnwBaseUrl: vnwBaseURL, classSelector: classSelector, userInfo: tempUserInfo, initData: initData })));
            // Render the full column
            if ((index + 1) % ITEMS_PER_SLIDE === 0) {
                slidesContent.push(React__default.createElement("div", { className: 'swiper-slide', key: ++slideIndex },
                    React__default.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16
                        } }, jobsPerPage)));
                jobsPerPage = [];
            }
            // Render the last column
            if (index === jobs.length - 1 && jobsPerPage.length > 0) {
                slidesContent.push(React__default.createElement("div", { className: 'swiper-slide', key: ++slideIndex },
                    React__default.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16
                        } }, jobsPerPage)));
            }
        });
        return slidesContent;
    };
    var renderContent = function () {
        var slidesContent = renderSlideContent();
        return (React__default.createElement("div", { className: 'swiper-container' }, isMobile ? (React__default.createElement(Slider, { id: 'recommend-jobs-mobile', slides: { spaceBetween: 16 }, pagination: { maxShow: 6, type: 'defaultNotArrow' }, loadingEnable: jobs.length === 0, loadingHeight: 445, container: { style: { width: '100%' } }, isRobot: isRobot }, slidesContent)) : (React__default.createElement(Slider, { id: 'recommend-jobs', slides: { elementPerView: 3, spaceBetween: 16 }, pagination: { maxShow: 8, elementPerPage: 2 }, loadingEnable: jobs.length === 0, loadingHeight: 345, container: { style: { width: '100%' } }, isRobot: isRobot }, slidesContent))));
    };
    var contentNode = renderContent();
    if (forceHidden) {
        return React__default.createElement(React__default.Fragment, null);
    }
    if (isWrapper) {
        return (React__default.createElement(Section, { title: sectionTitle, ctaLink: ctaLink }, contentNode));
    }
    return contentNode;
};

export { RecommnendJobs as default };
//# sourceMappingURL=index.js.map
